import { createSlice, createSelector } from "@reduxjs/toolkit";
import { apiCallBegan } from "./api";
import config from "../../config.json";

const slice = createSlice({
  name: "layoutUI",
  initialState: {
    list: [],
    loading: false,
    lastFetch: null,
    pageTitle: "",
    route: [],
    alertMessages: [],
    helpDocs: null,
  },
  reducers: {
    setCurrentPageTitle: (layoutUI, action) => {
      layoutUI.pageTitle = action.payload;
    },
    setCurrentRoute: (layoutUI, action) => {
      layoutUI.route = action.payload;
    },
    ruleAppDataReceived: (layoutUI, action) => {
      layoutUI.ruleAppData = action.payload;
    },
    alertMessagesReceived: (layoutUI, action) => {
      layoutUI.alertMessages = [...action.payload, ...layoutUI.alertMessages];
    },
    helpDocsReceived: (layoutUI, action) => {
      layoutUI.helpDocs = action.payload;
    },
  },
});

export const {
  setCurrentPageTitle,
  setCurrentRoute,
  alertMessagesReceived,
  helpDocsReceived,
} = slice.actions;
export default slice.reducer;

export const loadButtonAlertMessages = (id) =>
  apiCallBegan({
    url: config.GetFormProcessItems + id,
    onSuccess: alertMessagesReceived.type,
  });

export const loadWorkbenchHelpDocs = (id) =>
  apiCallBegan({
    url: config.GetHelpDocs + id,
    //responseType: "blob",
    onSuccess: helpDocsReceived.type,
  });

export const getPageTitle = createSelector(
  (state) => state.entities.layoutUI,
  (layoutUI) => layoutUI.pageTitle,
);

export const getPageRoute = createSelector(
  (state) => state.entities.layoutUI,
  (layoutUI) => layoutUI.route,
);

export const getButtonAlertMessages = createSelector(
  (state) => state.entities.layoutUI,
  (layoutUI) => layoutUI.alertMessages,
);

export const getWorkbenchHelpDocs = createSelector(
  (state) => state.entities.layoutUI,
  (layoutUI) => layoutUI.helpDocs,
);
